module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAAP0lEQVQ4y2P4jwQ+MAww7wADDNgPEh7/n8HBY/4PJgYDD+QohMsGnAck/v8f5aHx/qPE2IDyBkEuhvEGT1kHAOQdwg+Jw1KtAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTEzVDE1OjI3OjA4KzA5OjAwEILqywAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyMiswOTowMD+oKM0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_01652_100x100.png
// module id = InWz
// module chunks = 0